import React, { useState } from "react";
import {
  BusinessSection,
  FooterSection,
  HeroSection,
  HowItWorksSection,
  JoinListSection,
  Navbar,
  PricingSection,
  AgentSection,
  Sidebar,
} from "../Components";
import { busObj } from "../Components/BusinessSection/Data";
import { heroObj } from "../Components/HeroSection/Data";
import { joinObj } from "../Components/JoinListSection/Data";
import { priceObj } from "../Components/PricingSection/Data";
import { agentObj } from "../Components/AgentSection/Data";

const Home = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };
  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <HeroSection {...heroObj} />
      <HowItWorksSection />
      <AgentSection {...agentObj} />
      <BusinessSection {...busObj} />
      <PricingSection {...priceObj} />
      <JoinListSection {...joinObj} />
      <FooterSection />
    </>
  );
};

export default Home;
